import React from 'react';
import PropTypes from 'prop-types';
import './PanelColumns.scss';

export default class PanelColumns extends React.Component {

	static propTypes = {
		children: PropTypes.node,
		className: PropTypes.string,
		small: PropTypes.bool,
	};

	constructor(props) {
        super(props);
	}

	render() {
		let customClassName = this.props.className || '';
		let count = this.props.children.length || 1;

		return (
			<div className={customClassName + " panel-columns count-" + count} ref={box => {this.box = box;}}>
				{
					this.props.small
						? (<small>{this.props.children}</small>)
						: this.props.children
				}
			</div>
		);
	}
}
